/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum JobPeriodType {
    NONE = 'None',
    DAILY = 'Daily',
    MONTHLY = 'Monthly',
    WEEKLY = 'Weekly',
}
